// ======================================================================
// 📁 File: src/modules/ppe/components/machine/MachineKpiBar.jsx
// 📝 Purpose:
//   Machine Master – KPI Summary Bar
//   - Total Machines
//   - Active Machines
//   - Inactive Machines
//   - Bottleneck Machines
// ======================================================================

import React, { useMemo } from "react";

// ----------------------------------------------------------------------
export default function MachineKpiBar({ rows = [] }) {
  const kpis = useMemo(() => {
    const total = rows.length;
    const active = rows.filter((r) => r.is_active).length;
    const inactive = rows.filter((r) => !r.is_active).length;
    const bottleneck = rows.filter((r) => r.is_bottleneck).length;

    return [
      {
        label: "Total Machines",
        value: total,
        color: "#334155",
      },
      {
        label: "Active",
        value: active,
        color: "#16a34a",
      },
      {
        label: "Inactive",
        value: inactive,
        color: "#6b7280",
      },
      {
        label: "Bottleneck",
        value: bottleneck,
        color: "#dc2626",
      },
    ];
  }, [rows]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: 16,
        marginBottom: 20,
      }}
    >
      {kpis.map((kpi) => (
        <div
          key={kpi.label}
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: "16px 18px",
            boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          {/* Left color bar */}
          <div
            style={{
              width: 6,
              height: 48,
              borderRadius: 6,
              background: kpi.color,
            }}
          />

          {/* KPI Content */}
          <div>
            <div
              style={{
                fontSize: 13,
                color: "#64748b",
                marginBottom: 4,
              }}
            >
              {kpi.label}
            </div>
            <div
              style={{
                fontSize: 26,
                fontWeight: 600,
                color: "#0f172a",
              }}
            >
              {kpi.value}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
